import Backbone from 'backbone';

import EntryActions from 'actions/EntryActions';
import BenchlingConfig from 'BenchlingConfig';
import ExportActions from 'exports/ExportActions';
import {FolderDefaultsKey} from 'FolderDefaults';
import {Entry} from 'notebook/entries/backbone/filestate/Entry';
import EntityStore from 'stores/EntityStore';
import BasicInformationPanelView from 'toolbar/shared/BasicInformationPanelView';

class EntryInformationPanelView extends BasicInformationPanelView<Entry> {
  showPatentsafeExport!: boolean;

  override initialize(options?: Backbone.ViewOptions<Entry>): void {
    this.showPatentsafeExport = BenchlingConfig.ENABLE_PATENTSAFE && EntityStore.currentUser() != null;
    this.saveModel = this.saveModel.bind(this);
    this.deleteModel = this.deleteModel.bind(this);
    this.requestExport = this.requestExport.bind(this);
    super.initialize(options);
  }

  folderDefaultsKey(): FolderDefaultsKey {
    return FolderDefaultsKey.NOTEBOOK;
  }

  override saveModel(data: {name?: string; folder_id?: string}): void {
    EntryActions.saveFileData(this.model.id, {data, success: this.onSaveSuccess});
  }

  deleteModel(): void {
    EntryActions.delete(this.model.id, {success: this.onDeleteSuccess});
  }

  requestExport(): Promise<void> {
    return ExportActions.requestExportFile(this.model.id);
  }
}

export default EntryInformationPanelView;
